import { render, staticRenderFns } from "./auditShopCommunity.vue?vue&type=template&id=4b195ce2&scoped=true"
import script from "./auditShopCommunity.vue?vue&type=script&lang=js"
export * from "./auditShopCommunity.vue?vue&type=script&lang=js"
import style0 from "./auditShopCommunity.vue?vue&type=style&index=0&id=4b195ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b195ce2",
  null
  
)

export default component.exports